import spacing from '@/constants/spacing';
import {createThemedStyles} from '@/theme';

export const styles = createThemedStyles(() => ({
  container: {
    paddingBottom: spacing.m,
    width: '100%',
  },
  textContainer: {
    position: 'relative',
    overflow: 'hidden',
  },
  closed: {
    position: 'relative',
    height: 'auto',
  },
  full: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    height: 'auto',
  },
  seeMoreToggler: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
  },
}));
